import Model from '@/lib/data/Model';
import FormQuestionDataDocument from './FormQuestionDataDocument';
import RiskImprovement from './RiskImprovement';

class FormQuestionData extends Model {
    static idProperty = 'id';

    fields = [
        'id',
        'form_ques_id',
        { name: 'return_value', defaultValue: '' },
        { name: 'display_value', defaultValue: '' },
        { name: 'other_value', defaultValue: '' },
        'notes',
        {
            name: 'docs',
            association: {
                type: 'many',
                model: FormQuestionDataDocument,
            },
        },
        {
            name: 'risk_improvements',
            association: {
                type: 'many',
                model: RiskImprovement,
            },
        },
    ];

    constructor(data) {
        super(data);
        this.init();
    }
}

export default FormQuestionData;
